import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import Chip from '@material-ui/core/Chip'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'

import icons from 'icons'
import dateUtils from 'shared/src/date'

import CalendarBlock from './CalendarBlock'

const TodayIcon = icons.today

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '300px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    border: '1px dashed #ccc',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    padding: theme.spacing(2),
  },
  dateContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  date: {
    flexGrow: 1,
  },
  header: {
    margin: theme.spacing(1),
  },
  editableDay: {
    flexGrow: 0,
  },
  title: {
    color: '#666',
    fontWeight: 'bold',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  description: {
    color: '#999',
    '& p': {
      fontSize: '0.8em',
    },
  },
  blocks: {
    width: '100%',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  }
}))

const CalendarDay = ({
  admin,
  data,
  config,
  choosenSlot,
  wrapTitle,
  onClickSlot,
  onEditDay,
}) => {
  const classes = useStyles()
  const date = dateUtils.stringToDate(data.date)
  return (
    <div className={ classes.root }>
      <div className={ classes.dateContainer }>
        <div className={ classes.date }>
          <Chip
            icon={<TodayIcon />}
            label={ dateUtils.title(date) }
          />
        </div>
        {
          admin && data.meta.editable && onEditDay && (
            <div className={ classes.editableDay }>
              <Button
                size="small"
                color="primary"
                variant="outlined"
                onClick={ () => onEditDay(data) }
              >
                Edit
              </Button>
            </div>
          )
        }
      </div>
      
      <div className={ classes.header }>
        <div className={ classes.title }>
          <Typography variant="subtitle1">
            { data.name }
          </Typography>
        </div>
        {
          admin && (
            <div className={ classes.title }>
              <Typography variant="body1">
                schedule: { data.schedule }
              </Typography>
            </div>
          )
        }
        <div className={ classes.description }>
          {
            data.statusMessage ? (
              <Typography variant="body1" color="primary">
                <strong>{ data.statusMessage }</strong>
              </Typography>
            ) : (
              <Typography variant="body1">
                { data.meta.description }
              </Typography>
            )
          }
        </div>
      </div>
      <div className={ classes.blocks }>
        {
          data.blocks.map((block, i) => {
            return (
              <React.Fragment key={ i }>
                <CalendarBlock
                  admin={ admin }
                  data={ block }
                  config={ config }
                  choosenSlot={ choosenSlot }
                  wrapTitle={ wrapTitle }
                  onClickSlot={ onClickSlot }
                />
                <Divider className={ classes.divider } />
              </React.Fragment>
            )
          })
        }
      </div>
    </div>
  )
}

export default CalendarDay